import React from 'react';
import classNames from 'classnames';
import { RefreshIcon } from '@heroicons/react/outline';
import padlock from '../../assets/svgs/padlock.svg';

interface FormSaveStatusProps {
  isSaving: boolean;
  lastSaved: Date | null;
  saveError: Error | null;
  className?: string;
}

export const FormSaveStatus: React.FC<FormSaveStatusProps> = ({
  isSaving,
  lastSaved,
  saveError,
  className,
}) => {
  if (isSaving) {
    return (
      <div
        className={classNames(
          'flex flex-row items-center justify-center gap-x-1 text-center text-small-caption text-neutral-125 transition-opacity duration-300',
          className,
        )}
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        <RefreshIcon className="h-4 w-4" />
        Saving...
      </div>
    );
  }

  if (saveError) {
    return (
      <div
        className={classNames(
          'text-red-500 flex flex-row items-center justify-center gap-x-1 text-center text-small-caption transition-opacity duration-300',
          className,
        )}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        Failed to save
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div
        className={classNames(
          'flex flex-row items-center justify-center gap-x-1 text-center text-small-caption text-neutral-125 transition-opacity duration-300',
          className,
        )}
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        Form responses saved
        <img src={padlock} alt="auto-saved" className="h-4 w-4" />
      </div>
    );
  }

  return null;
};
